import throttle from 'lodash/throttle';

export default (element, options = {}) => {
  if (typeof element === 'string') {
    element = document.querySelector(element);
  }

  const listener = throttle(handler, 50);

  let scrolled = 0;
  let position = window.scrollY;
  let delta = 1;

  let {
    threshold,
    disabled,
    status
  } = Object.assign({
    threshold: 150,
    disabled: false,
    status: true,
  }, options);

  window.addEventListener('scroll', listener);

  // Apply initial classes
  apply();

  function handler() {
    if (disabled) return;

    const currentPosition = window.scrollY;
    const currentDelta = position - currentPosition;

    // Wait for the next tick if the current delta is zero so that the change of
    // the scroll direction is recognized correctly
    if (currentDelta === 0) return;

    scrolled += currentDelta;

    // Reset scrolled when the scroll dirction changes
    if (Math.sign(currentDelta) + Math.sign(delta) === 0) {
      scrolled = 0;
    }

    position = currentPosition;
    delta = currentDelta;

    if (status === true && currentPosition > 0 && scrolled + threshold < 0) {
      hide();
    } else if (status === false && scrolled > 10) {
      show();
    }
  }

  function predict(offset) {
    let currentScrolled = scrolled;

    // Reset scrolled when the scroll dirction would change
    if (Math.sign(offset) + Math.sign(delta) === 0) {
      currentScrolled = 0;
    }

    currentScrolled += offset;

    if (currentScrolled + threshold < 0) {
      return 'hidden';
    } else if (currentScrolled > 10) {
      return 'visible';
    }

    return status ? 'visible' : 'hidden';
  }

  function apply() {
    element.setAttribute('aria-hidden', !status);
  }

  function hide() {
    if (status === false) {
      return;
    }

    scrolled = 0;
    status = false;

    apply();
  }

  function show() {
    if (status === true) {
      return;
    }

    scrolled = 0;
    status = true;

    apply();
  }

  function enable() {
    position = window.scrollY;
    disabled = false;
    scrolled = 0;
  }

  function disable() {
    disabled = true;
  }

  function destroy() {
    window.removeEventListener('scroll', listener);
  }

  return {
    element,
    hide,
    show,
    enable,
    disable,
    destroy,
    predict,
  }
}
